/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RfidUploadEntity } from "./RfidUploadEntity";
import {
    RfidUploadEntityFromJSON,
    RfidUploadEntityFromJSONTyped,
    RfidUploadEntityToJSON,
} from "./RfidUploadEntity";

/**
 *
 * @export
 * @interface RfidBulkUploadRequest
 */
export interface RfidBulkUploadRequest {
    /**
     * True to perform validation only, false to perfrom db operations
     * @type {boolean}
     * @memberof RfidBulkUploadRequest
     */
    validateOnly?: boolean;
    /**
     * List of rfid items of the same type as the CSV structure (similar, but not the same, as RfidTagDto)
     * @type {Array<RfidUploadEntity>}
     * @memberof RfidBulkUploadRequest
     */
    rfidUploadEntities?: Array<RfidUploadEntity>;
}

/**
 * Check if a given object implements the RfidBulkUploadRequest interface.
 */
export function instanceOfRfidBulkUploadRequest(
    value: object,
): value is RfidBulkUploadRequest {
    return true;
}

export function RfidBulkUploadRequestFromJSON(
    json: any,
): RfidBulkUploadRequest {
    return RfidBulkUploadRequestFromJSONTyped(json, false);
}

export function RfidBulkUploadRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): RfidBulkUploadRequest {
    if (json == null) {
        return json;
    }
    return {
        validateOnly:
            json["validateOnly"] == null ? undefined : json["validateOnly"],
        rfidUploadEntities:
            json["rfidUploadEntities"] == null
                ? undefined
                : (json["rfidUploadEntities"] as Array<any>).map(
                      RfidUploadEntityFromJSON,
                  ),
    };
}

export function RfidBulkUploadRequestToJSON(
    value?: RfidBulkUploadRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        validateOnly: value["validateOnly"],
        rfidUploadEntities:
            value["rfidUploadEntities"] == null
                ? undefined
                : (value["rfidUploadEntities"] as Array<any>).map(
                      RfidUploadEntityToJSON,
                  ),
    };
}
